import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { withAppState } from "../../state";
import { withRouter } from "react-router-dom";
import getMenuItems from "./menuItems";
import { SideMenu, Menus, MenuItem } from "../../services/visualLibraryService";
import { i18n } from "../../services/i18nService";
import { getLogger } from "../../utils/logger";
import { trackEvent } from "../../services/analyticsService";
import { routes } from "../../routes/routes";
import { getCurrentProfile } from "../../services/multipleProfilesService";
import { redirectTo } from "../../services/navigationService";
import { getSdk } from "../../services/sdkService";
import { isLowEndLGFromWebOS5 } from "../../utils/checkLgNewModel";

const SP_ICON_URL =
  "https://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/bigscreen/images/icons/navbar/starzplay.png";
const SPORTS_ICON_URL =
  "https://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/bigscreen/images/icons/navbar/sports.png";
const ICC_CHAMPIONS_TROPHY_ICON_URL =
  "https://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/bigscreen/images/icons/navbar/championstrophy2025.png";
const ADMN_URL = `https://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/bigscreen/images/icons/navbar/admn.${
  isLowEndLGFromWebOS5() ? "png" : "svg"
}`;

let carousel;
let menuFocused = false;
let isMagicRemoteActive = false;
let selectedIndex;
const loginSignupFocusPath = "globalModalSectionSignupFocusPath_passThru";
const exitModalFocusPath = "globalModalNoFocusPath_passThru";
const categoriesModalFocusPath = "menu_brands_passThru";

function goToSlideWithSetTimeout(index) {
  setTimeout(() => {
    carousel.goTo(index);
  }, 300);
}

class MainMenuContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLogged: props.applicationState.userLogged,
      menuIndex: props.applicationState.focusedMainMenuItemIndex,
      menuFocusedIndex: props.applicationState.focusedMainMenuItemIndex,
      showModal: false,
      currentProfile: null
    };
    this.items = [];
    this.navigate = this.navigate.bind(this);
    this.handleNavigation = this.handleNavigation.bind(this);
    this.isReadyToRender = this.isReadyToRender.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleClickNavigation = this.handleClickNavigation.bind(this);
    this.handleOppositeSlidesNavigation = this.handleOppositeSlidesNavigation.bind(this);
    this.redirectToPinLockForKids = this.redirectToPinLockForKids.bind(this);
    this.logger = getLogger();
    this.mouseScroll = true;
  }

  closeModal() {
    const {
      stateActions: { hideGlobalModal }
    } = this.props;
    hideGlobalModal();
    this.setState({
      showModal: false
    });
    this.props.setFocus("mainMenu");
  }

  async redirectToPinLockForKids() {
    const profile = await getCurrentProfile();
    if (profile && profile?.isKidLockEnabled) {
      redirectTo.call(this, routes.pinLock, {
        nextPage: routes.profileSelector,
        backDestination: routes.home,
        profileName: profile?.profileName,
        profileId: profile?.profileId,
        profileData: profile,
        isVerifyPin: true,
        fromNavbar: true
      });
      return;
    }
  }
  async navigate() {
    this.props.stateActions.setCarouselFocus(0);

    const item = getMenuItems(this.state.currentProfile, this.redirectToPinLockForKids)[this.state.menuFocusedIndex];
    if (item.path === routes.profileSelector) {
      const profile = await getCurrentProfile();
      trackEvent("switch_profile_clicked", null, "MP", this.state.currentProfile);
      if (profile && profile?.isKidLockEnabled) {
        return await this.redirectToPinLockForKids();
      }
    }
    const itemName = item.path ? item.path.split("/")[1] : "";
    const action = item.isRoot ? this.props.history.replace : this.props.history.push;
    trackEvent("navigation", itemName, itemName);
    if (item.showModal && item.callback) {
      this.setState({ showModal: true });
      return item.callback.call(this);
    }
    if (item.callback) {
      const returnValue = item.callback.call(this);
      if (returnValue) {
        return;
      }
    }
    if (item.path !== "/exit") {
      action(item.path, { preserveFocus: item.isRoot });
    }
  }

  left() {
    carousel.left();
  }

  right() {
    carousel.right();
  }

  rightMenuHandler() {
    const { lastFocusedName } = this.props.applicationState;
    const { showModal, menuFocusedIndex } = this.state;
    const item = getMenuItems(this.state.currentProfile, this.redirectToPinLockForKids)[menuFocusedIndex];
    if (showModal) {
      this.setState({ showModal: false });
    }
    this.props.handleToggleMenu(false);
    if (showModal) {
      item.showNotLoggedModal
        ? this.props.setFocus(loginSignupFocusPath)
        : item.showCategoriesModal
        ? this.props.setFocus(categoriesModalFocusPath)
        : item.showExitModal && this.props.setFocus(exitModalFocusPath);
    } else {
      this.props.setFocus(lastFocusedName !== "lists" ? "lists" : lastFocusedName);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    isMagicRemoteActive = getSdk().systemManager.application.checkMagicRemote();
    return (
      menuFocused === false ||
      this.props.focused !== nextProps.focused ||
      // FIXME: As we know this is nasty, the state should be a flat object, not referencing other objects.
      // 💩👇
      this.state.currentProfile !== nextState.currentProfile ||
      this.state.menuIndex !== nextProps.applicationState.focusedMainMenuItemIndex ||
      this.state.menuIndex !== nextState.menuIndex ||
      this.props.menuExpanded !== nextProps.menuExpanded ||
      this.state.menuFocusedIndex !== nextState.menuFocusedIndex
    );
  }

  async componentDidMount() {
    // FIXME: As we know this is nasty, the state should be a flat object, not referencing other objects.
    // 💩👇
    this.setState({
      isLogged: this.props.applicationState.userLogged,
      menuIndex: this.props.applicationState.focusedMainMenuItemIndex,
      menuFocusedIndex: this.props.applicationState.focusedMainMenuItemIndex
    });
    const currentProfile = await getCurrentProfile();
    this.setState({ currentProfile });
    this.parentalLevel = this.props.applicationState.parentalLevel;
    this.props.onRef && this.props.onRef(this);
  }

  async componentDidUpdate() {
    const {
      handleFocus,
      focused,
      applicationState: { focusedMainMenuItemIndex, userLogged, parentalLevel }
    } = this.props;
    if (this.state.menuFocusedIndex !== focusedMainMenuItemIndex && this.props?.history?.location?.search !== "") {
      this.setState({ menuFocusedIndex: focusedMainMenuItemIndex });
    }

    const currentProfile = await getCurrentProfile();
    handleFocus(focused);
    if (!focused) {
      this.props.handleToggleMenu(false);
    }
    if (
      this.state.isLogged !== userLogged ||
      this.state.menuIndex !== focusedMainMenuItemIndex ||
      this.parentalLevel !== parentalLevel ||
      (this.state.currentProfile && this.state.currentProfile.profileName) !==
        (currentProfile && currentProfile.profileName)
    ) {
      this.parentalLevel = parentalLevel;
      this.setState({
        isLogged: userLogged,
        menuIndex: focusedMainMenuItemIndex,
        menuFocusedIndex: focusedMainMenuItemIndex,
        currentProfile: currentProfile
      });
    }
    menuFocused = true;
    isMagicRemoteActive = getSdk().systemManager.application.checkMagicRemote();
  }

  componentWillUnmount() {
    menuFocused = false;
  }

  handleOppositeSlidesNavigation(oldIndex, newIndex) {
    if (newIndex === carousel.currentSlide) {
      if (carousel.isFirstSlide) {
        goToSlideWithSetTimeout(carousel.slideCount - 1);
      } else if (carousel.isLastSlide) {
        goToSlideWithSetTimeout(0);
      }
    }
  }

  handleNavigation(index) {
    selectedIndex = index;
    this.setState({ menuFocusedIndex: index });
    this.props.handleToggleMenu(true);
    this.props.applicationState.focusedMainMenuItemIndex = index;
  }

  handleClickNavigation() {
    this.props.stateActions.setCarouselFocus(0);
  }

  async checkInitialSlideIndex() {
    const {
      applicationState: { focusedMainMenuItemIndex },
      location
    } = this.props;
    let index =
      focusedMainMenuItemIndex > getMenuItems(this.state.currentProfile).length - 1 ? 0 : focusedMainMenuItemIndex;
    if (location.pathname) {
      index = (getMenuItems(this.state.currentProfile) || []).findIndex(values => values.path === location.pathname);
    }
    selectedIndex = index;
    this.props.applicationState.focusedMainMenuItemIndex = index;
  }

  isReadyToRender() {
    const { isLogged, menuIndex } = this.state;
    return (
      isLogged === this.props.applicationState.userLogged &&
      menuIndex === this.props.applicationState.focusedMainMenuItemIndex
    );
  }

  returnMenuImage(menuitem) {
    switch (menuitem.icon) {
      case "premium":
        return SP_ICON_URL;
      case "premium_focused":
        return SP_ICON_URL;
      case "sports":
        return SPORTS_ICON_URL;
      case "sports_focused":
        return SPORTS_ICON_URL;
      // case "championstrophy2025":
      //   return ICC_CHAMPIONS_TROPHY_ICON_URL;
      // case "championstrophy2025_focused":
      //   return ICC_CHAMPIONS_TROPHY_ICON_URL;
      case "mpPicture":
        return menuitem.background;
      case "admn":
        return ADMN_URL;
      default:
        return null;
    }
  }

  render() {
    const { isLogged } = this.state;
    const menu = getMenuItems(this.state.currentProfile, this.redirectToPinLockForKids);
    this.checkInitialSlideIndex();

    return (
      <header style={{ height: "100%" }}>
        {// FIXME: Carousel items are forced to match the used state as logged in or not.
        this.isReadyToRender() && (
          <SideMenu>
            <Menus
              type="icon"
              ref={ref => (carousel = ref)}
              onChange={this.handleNavigation}
              initialSlide={this.props.applicationState.focusedMainMenuItemIndex || 0}
              itemsLength={menu.length}
              onMouseUp={this.handleClickNavigation}
            >
              {menu.map((item, index) => {
                return (
                  <MenuItem
                    type={
                      (item.visibleOnMenuExpand && (this.props.menuExpanded || this.props.focused)) ||
                      !item.visibleOnMenuExpand
                        ? "icon"
                        : ""
                    }
                    key={`item_${item.name}_${index}_${new Date().getTime()}`}
                    to={item.path || "#"}
                    label={item.name && i18n.get(`global.sections.${item.name}`)}
                    icon={
                      this.props.location.pathname === item.path && index === this.state.menuFocusedIndex
                        ? `${item.icon}_focused`
                        : index === this.state.menuFocusedIndex
                        ? `${item.icon}_focused`
                        : this.props.location.pathname === item.path && index !== this.state.menuFocusedIndex
                        ? item.icon
                        : item.icon
                    }
                    image={this.returnMenuImage(item)}
                    use={NavLink}
                    active={this.props.location.pathname === item.path ? 1 : 0}
                    isLogged={isLogged}
                    onRef={ref => this.items.push(ref)}
                    focused={index === this.state.menuFocusedIndex ? 1 : 0}
                    separator={item.separator ? 1 : 0}
                    menuExpanded={this.props.menuExpanded || this.props.focused}
                    size={item.listStyle}
                    visibleOnMenuExpand={item.visibleOnMenuExpand}
                    isDummyMenuItem={item.isDummyMenuItem}
                    marginBottom={item.marginBottom}
                    seperatorBottom={item.seperatorBottom}
                    secondLevelTitle={item.secondLevelTitle}
                    showInSection={item.showInSection}
                    onClick={item.onClick || null}
                  />
                );
              })}
            </Menus>
            <Menus
              type="text"
              className="expandedMenu"
              itemsLength={menu.length}
              menuExpanded={this.props.menuExpanded || this.props.focused}
            >
              {menu.map((item, index) => {
                return (
                  <MenuItem
                    type="text"
                    key={`item_${item.name}_${index}_${new Date().getTime()}`}
                    to={item.path || "#"}
                    label={
                      item.customTranslation
                        ? item.customTranslation
                        : item.name && i18n.get(`global.sections.${item.name}`)
                    }
                    use={NavLink}
                    active={this.props.location.pathname === item.path ? 1 : 0}
                    isLogged={isLogged}
                    onRef={ref => this.items.push(ref)}
                    focused={index === this.state.menuFocusedIndex ? 1 : 0}
                    separator={item.separator ? 1 : 0}
                    menuExpanded={this.props.menuExpanded || this.props.focused}
                    size={item.listStyle}
                    isDummyMenuItem={item.isDummyMenuItem}
                    marginBottom={item.marginBottom}
                    takeIconSpace={item.takeIconSpace}
                    seperatorBottom={item.seperatorBottom}
                    secondLevelTitle={item.secondLevelTitle}
                    showInSection={item.showInSection}
                    onClick={item.onClick || null}
                  />
                );
              })}
            </Menus>
          </SideMenu>
        )}
      </header>
    );
  }
}

export default withRouter(withAppState(MainMenuContainer));
